export default "__VITE_ASSET__BYKOpmsG__"